import React, { useCallback, useEffect, useState } from 'react'
import { useAdvancedOverviewState } from '../api/AdvancedOverviewProvider'
import { usePersistedState } from '../api/localStore'
import { useTabNavigation } from '../dashboard/tabNavigationContext'
import { useEditMode } from '../dashboard/useEditMode'
import { TOUR_STEPS, TourStepDefinition, selectTourSteps } from './steps'
import { useTourRequest } from './tourRequest'
import TourRunner from './TourRunner'

export const TOUR_SEEN_KEY = 'advanced.tour.seen.v1'

type Props = { setCareTeamChatOpen?: (open: boolean) => void }

const AdvancedTour = ({ setCareTeamChatOpen }: Props) => {
  const tourRequest = useTourRequest()
  const overview = useAdvancedOverviewState()
  const [editMode] = useEditMode()
  const { openTab, hasTab } = useTabNavigation()
  const [seen, setSeen] = usePersistedState(TOUR_SEEN_KEY, false)
  const [steps, setSteps] = useState<TourStepDefinition[] | null>(null)
  const endTour = useCallback(() => setSteps(null), [])

  const ready = overview.status === 'ready'
  const wanted = tourRequest !== null && (tourRequest.requested || (!seen && !editMode))

  useEffect(() => {
    if (!tourRequest || !ready || !wanted) {
      return
    }
    tourRequest.onHandled()
    if (steps) {
      return
    }
    setSeen(true)
    setSteps(selectTourSteps(TOUR_STEPS, hasTab))
  }, [tourRequest, ready, wanted, steps, hasTab, setSeen])

  if (!steps) {
    return null
  }

  return <TourRunner steps={steps} openTab={openTab} onEnd={endTour} setCareTeamChatOpen={setCareTeamChatOpen} />
}

export default AdvancedTour
